import React from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router";
import { CSSTransition } from "react-transition-group";
import { Button, Loader, Modal, Notification, toaster } from "rsuite";
import { ModuleContext } from "../../components/authProvider/main";
import Browserlize from "../../components/Browserlize";
import axios from "../../utilities/axios";

import { Differencify } from "../../components/differencify/main";
import { WYSIWYG } from "../../components/formfields/WYSIWYG";
import config from "../../globals";
import iziToast from "izitoast";

class BrowsePage extends React.Component<any, {}> {
  static contextType = ModuleContext;

  public crud: any = this.props.match.params.crud;
  public state: any = {
    formData: {},
    isMounted: false,
    isModalOpen: false,
    isLoading: false,
    logData: {},
    exclusionMotive: "",
  };

  private getter: Promise<void> | null | undefined = null;

  public nodeRef: any = null;

  constructor(props: any) {
    super(props);
    this.nodeRef = React.createRef();
  }

  componentDidMount = () => {
    const { crud } = this.props.match.params;
    (this.context as any).setModule(null, null, crud);
    this.loadItems();
  };

  loadItems = () => {
    axios
      .get("/api/v1/" + this.crud + "/fields")
      .then((res) => {
        if (
          res.data &&
          res.data.fields &&
          res.data.fields.$GLOBALS &&
          res.data.fields.$GLOBALS.table
        ) {
          this.setState({ formData: res.data.fields });
        }
      })
      .finally(() => { })
      .catch((e) => { });
  };

  componentDidUpdate(prevProps: any) {
    if (
      this.props.location.pathname !== prevProps.location.pathname &&
      this.props.match.params.crud !== prevProps.match.params.crud
    ) {
      this.crud = this.props.match.params.crud;

      (this.context as any).setModule(null, null, this.crud);
      (this.context as any).setPage(this.crud);
      this.setState({ formData: {} }, () => {
        this.loadItems();
      });
    }
  }

  onEdit = (id: string) => {
    this.props.history.push(this.props.location.pathname + "/" + id);
    localStorage.setItem("searchHistoric", this.props.location.search);
  };

  onRead = (id: string) => {
    this.props.history.push(this.props.location.pathname + "/view/" + id);
    localStorage.setItem("searchHistoric", this.props.location.search);
  };

  public deletingId: string | null = null;
  public deleteCallback: Function | null = null;

  onDelete = (id: string, callBack: Function = function () { }) => {
    this.deletingId = id;
    this.deleteCallback = callBack;
    this.setState({ isModalOpen: "delete" });
  };

  renderLogs = () => {
    return (
      <Differencify fields={this.state.formData} logs={this.state.logData} />
    );
  };

  showLog = (id: string) => {
    this.setState({ isModalOpen: "logs", isLoading: true });
    axios
      .get("/api/v1/logs/" + this.crud + "/" + id)
      .then((res) => {
        if (res && res.data && res.data.logs) {
          this.setState({ logData: res.data.logs, isLoading: false });
        }
      })
      .catch(function () { });
  };

  onConfirmDelete = () => {
    this.setState({ isLoading: true });
    axios
      .post("/api/v1/" + this.crud + "/delete/" + this.deletingId)
      .then((res) => {
        if (res.data.status === 200) {
          iziToast.success({
            title: "Sucesso!",
            message: "Registo excluido com sucesso!",
            position: "topRight",
            close: true,
          });

        }
      })
      .finally(() => {
        this.setState({ isModalOpen: false, isLoading: false }, () => {
          if (this.deleteCallback) {
            this.deleteCallback();
          }
        });
      })
      .catch((e) => {
        if (e.response.data.status === 403) {
          iziToast.error({
            title: "Erro!",
            message: e.response.data.errors,
            position: "topRight",
            close: true,
          });

        } else {
          iziToast.error({
            title: "Erro!",
            message: "Não foi possível deletar esse registro!",
            position: "topRight",
            close: true,
          });

        }
      });
  };

  isLoadingClass() {
    if (this.state.isLoading) {
      return {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      };
    }
    return {};
  }

  actions = (id: string) => { };

  onRowDoubleClick = (row: any) => {
    if (this.state.formData) {
      const { $GLOBALS } = this.state.formData;
      if ($GLOBALS) {
        const index = $GLOBALS.prefix + "_id";
        if (row && row[index] && $GLOBALS.edit !== false) {
          const id = row[index];

          this.props.history.push(
            "/dashboard/" + (this.context as any).name + "/" + this.crud + "/" + id
          );
        }
      }
    }
  };

  render() {
    return (
      <div>
        <Helmet>
          <title>
            {config.projectName}{" "}
            {this.state.formData?.$GLOBALS?.singular_name
              ? "- " + this.state.formData?.$GLOBALS?.singular_name
              : this.crud}
          </title>
        </Helmet>
        <Modal
          overflow={false}
          open={this.state.isModalOpen === "logs"}
          size={"lg"}
          className="centered"
        >
          <Modal.Header closeButton={false}>
            <Modal.Title>
              <i
                className="fas fa-fw mr-2 fa-question-circle"
                style={{ color: "#0096a0", fontSize: 24 }}
              ></i>
              Logs recentes
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={this.isLoadingClass()}>
            {this.state.isLoading && <Loader size="md" />}
            {!this.state.isLoading && this.renderLogs()}
          </Modal.Body>
          <Modal.Footer>
            <Button
              disabled={this.state.isLoading}
              type="button"
              onClick={() => this.setState({ isModalOpen: false })}
            >
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          open={this.state.isModalOpen === "delete"}
          size={"sm"}
          className="centered"
        >
          <Modal.Header closeButton={false}>
            <Modal.Title>
              <i
                className="fas fa-fw mr-2 fa-exclamation-triangle"
                style={{ color: "#ffb300", fontSize: 24 }}
              ></i>
              Atenção!
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={this.isLoadingClass()}>
            {this.state.isLoading && <Loader size="md" />}
            {!this.state.isLoading && (
              <>
                Deseja mesmo excluir esse registro ? O registro não poderá ser
                restaurado!
              </>
            )}
            {!this.state.isLoading && (
              <WYSIWYG
                placeholder={"Digite o motivo"}
                onChange={(value: string) =>
                  this.setState({ exclusionMotive: value })
                }
                className="mt-4"
              ></WYSIWYG>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              disabled={this.state.isLoading}
              appearance="primary"
              onClick={this.onConfirmDelete}
            >
              <i className="fas fa-check fa-fw mr-2"></i>Confirmar
            </Button>
            <Button
              disabled={this.state.isLoading}
              color="red"
              onClick={() => this.setState({ isModalOpen: false })}
            >
              <i className="fas fa-times fa-fw mr-2"></i>Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
        <CSSTransition
          nodeRef={this.nodeRef}
          in={true}
          classNames="anim-top"
          unmountOnExit
          timeout={200}
        >
          <div
            className="container"
            style={{
              marginLeft:
                localStorage.getItem("hiddenSidebar") === "true"
                  ? "0px"
                  : "203px",
            }}
          >
            {Object.keys(this.state.formData).length > 0 && (
              <Browserlize
                onRowDoubleClick={this.onRowDoubleClick}
                actions={this.actions}
                onRead={this.onRead}
                onDelete={this.onDelete}
                onEdit={this.onEdit}
                module={(this.context as any).name}
                form={this.state.formData}
                name={this.crud}
              ></Browserlize>
            )}
          </div>
        </CSSTransition>
      </div>
    );
  }
}

export default withRouter(BrowsePage);
